import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Platform} from '@angular/cdk/platform';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';


import {locale as navigationEnglish} from '../app/navigation/i18n/en';
import {locale as navigationTurkish} from '../app/navigation/i18n/bn';
import {AuthService} from './services/auth.service';
import {User} from './dto/user';
import {Module} from './dto/module';
import {Title} from '@angular/platform-browser';
import {getOrganizationTheme} from './services/utilities';
import {navigation} from './navigation/navigation';
import {FuseNavigationService} from '../@fuse/components/navigation/navigation.service';
import {FuseSplashScreenService} from '../@fuse/services/splash-screen.service';
import {FuseSidebarService} from '../@fuse/components/sidebar/sidebar.service';
import {FuseConfigService} from '../@fuse/services/config.service';
import {FuseTranslationLoaderService} from '../@fuse/services/translation-loader.service';
import {Organization} from './dto/organization';
import {BaseService} from './services/base.service';
import {GeneralBroadcastService} from './services/general-broadcast.service';
import {AppConfigService} from './services/app-config.service';
import {Router} from '@angular/router';

declare let $: any;

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    fuseConfig: any;
    navigation: any;
    loggedUser: User;
    isOrgAdmin = false;
    isSuperAdmin = false;
    organizationList: Organization[] = [];

    private _unsubscribeAll: Subject<any>;

    constructor(@Inject(DOCUMENT) private document: any,
                private _fuseConfigService: FuseConfigService,
                private _fuseNavigationService: FuseNavigationService,
                private _fuseSidebarService: FuseSidebarService,
                private _fuseSplashScreenService: FuseSplashScreenService,
                private _fuseTranslationLoaderService: FuseTranslationLoaderService,
                private _translateService: TranslateService,
                private _platform: Platform,
                private _titleService: Title,
                private auth: AuthService,
                private service: BaseService,
                private generalBroadcastService: GeneralBroadcastService,
                private router: Router,
                private configService: AppConfigService,
    ) {
        this.loggedUser = this.auth.user;

        if (this.loggedUser) {
            document.getElementById('favicon').href = this.loggedUser.Organization.Logo;
            this._fuseConfigService.setConfig(getOrganizationTheme(this.loggedUser.Organization.Code));
        }
        // <editor-fold desc="Process left sidebar navigation" defaultstate="collapsed">
        let userNavigation = [];
        const tempNavReportModule = [];

        if (this.loggedUser) {
            this.isOrgAdmin = this.auth.isOrgAdmin;
            this.isSuperAdmin = this.auth.isSuperAdmin;
            if (this.isSuperAdmin) {
                navigation.forEach(pNavItem => {
                    if (pNavItem.id === 'superadmin') {
                        if (this.loggedUser.Organization.Code === 'BZM') {
                            pNavItem.isActive = true;
                            pNavItem.children.forEach(pNavChildren => {
                                pNavChildren.isActive = true;
                                userNavigation.push(pNavChildren);
                            });
                        }
                    }
                });
            } else {
                navigation.forEach(pNavItem => {
                    if (pNavItem.id === 'REPORT') {
                        const navReportModule = [];
                        if (pNavItem.children && pNavItem.children.length > 0) {
                            pNavItem.children.forEach(pNavItemReportModule => {
                                // pNavItemReportModule.isActive = this._checkNavAccess(pNavItemReportModule.id.replace(/_report/g, ''), this.loggedUser.UserRole.ModuleList, false);
                                const navReport = [];
                                if (pNavItemReportModule.children && pNavItemReportModule.children.length > 0) {
                                    pNavItemReportModule.children.forEach(pNavItemReport => {
                                        pNavItemReport.isActive = this._checkNavAccess(pNavItemReport.id, this.loggedUser.UserRole.ModuleList, true);
                                        if (pNavItemReport.isActive) {
                                            if (pNavItemReport.id == 'REPORT_DCR_COUNT_BY_PRODUCT_SEGMENT') {
                                                if (this.service.segmentsForReports.length > 0) {
                                                    this.service.segmentsForReports.forEach(pSegment => {
                                                        navReport.push({
                                                            id: 'REPORT_DCR_COUNT_BY_PRODUCT_SEGMENT',
                                                            title: pSegment.Name + ' WISE DCR Count',
                                                            type: 'item',
                                                            url: '/report-dcr/segment-wise-dcr-report/' + pSegment.Id,
                                                            isActive: true
                                                        })
                                                    })
                                                }
                                            } else {
                                                navReport.push(pNavItemReport);
                                            }
                                        }
                                    });
                                }
                                if (navReport.length > 0) {
                                    pNavItemReportModule.children = navReport;
                                    pNavItemReportModule.isActive = true;
                                    navReportModule.push(pNavItemReportModule);
                                }
                            });
                        }

                        navReportModule.sort((one, two) =>
                            (one.title > two.title ? 1 : -1));
                        tempNavReportModule.push(navReportModule);

                        if (navReportModule.length > 0) {
                            pNavItem.isActive = true;
                            pNavItem.children = navReportModule;
                            userNavigation.push(pNavItem);
                        }
                    } else {
                        pNavItem.isActive = this._checkNavAccess(pNavItem.id, this.loggedUser.UserRole.ModuleList, false);
                        if (pNavItem.isActive) {
                            pNavItem.children.forEach(pSideBarMenu => {
                                const topBarItems = [];
                                if (pSideBarMenu.children && pSideBarMenu.children.length > 0) {
                                    pSideBarMenu.children.forEach(pTopBarMenu => {
                                        const topBarMenuChildren = [];
                                        if (pTopBarMenu.children && pTopBarMenu.children.length > 0) {
                                            pTopBarMenu.children.forEach(pTopBarChild => {
                                                if (pTopBarChild.second_set_id) {
                                                    const isFirstSetActive = this._checkNavAccess(pTopBarChild.id, this.loggedUser.UserRole.ModuleList, true);
                                                    const isSecondSetActive = this._checkNavAccess(pTopBarChild.second_set_id, this.loggedUser.UserRole.ModuleList, true);
                                                    pTopBarChild.isActive = isFirstSetActive && isSecondSetActive;
                                                } else {
                                                    pTopBarChild.isActive = this._checkNavAccess(pTopBarChild.id, this.loggedUser.UserRole.ModuleList, true);
                                                }

                                                if (pTopBarChild.isActive) {
                                                    topBarMenuChildren.push(pTopBarChild);
                                                } else {
                                                    pTopBarChild.isActive = this._checkNavAccess(pTopBarChild.id, this.loggedUser.UserRole.ModuleList, false);
                                                    if (pTopBarChild.isActive) {
                                                        topBarMenuChildren.push(pTopBarChild);
                                                    }
                                                }

                                            });
                                        } else {
                                            if (pTopBarMenu.id == 'WEB_MENU_MARKET_STRUCTURE') {
                                                pTopBarMenu.isActive = this._checkNavAccess(pTopBarMenu.id, this.loggedUser.UserRole.ModuleList, true);
                                                if (pTopBarMenu.isActive && this.loggedUser.MarketLevelHierarchy && this.loggedUser.MarketLevelHierarchy.length > 0) {
                                                    this.loggedUser.MarketLevelHierarchy.forEach(pMarketLevel => {
                                                        if (pMarketLevel != null && pMarketLevel.Name != null) {
                                                            topBarMenuChildren.push({
                                                                id: pMarketLevel.Name.toLowerCase(),
                                                                title: pMarketLevel.Name,
                                                                type: 'item',
                                                                url: '/market/list/' + pMarketLevel.Id,
                                                                isActive: true,
                                                                description: ''
                                                            });
                                                        }
                                                    });
                                                }
                                            } else if (pTopBarMenu.id == 'ADMIN') {
                                                pTopBarMenu.isActive = this._checkNavAccess(pTopBarMenu.id, this.loggedUser.UserRole.ModuleList, false);
                                                if (pTopBarMenu.isActive) {
                                                    if (this._checkNavAccess('ADMIN_ACCESS', this.loggedUser.UserRole.ModuleList, true)) {
                                                        topBarMenuChildren.push({
                                                            id: 'ADMIN_ACCESS',
                                                            title: 'Permissions and Settings',
                                                            type: 'item',
                                                            url: '/admin-settings/' + this.loggedUser.Organization.Id,
                                                            isActive: true,
                                                            description: ''
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                        pTopBarMenu.children = topBarMenuChildren;
                                        if (topBarMenuChildren.length > 0) {
                                            topBarItems.push(pTopBarMenu);
                                        }
                                    });
                                }
                                pSideBarMenu.children = topBarItems;
                                if (pSideBarMenu.children.length > 0) {
                                    userNavigation.push(pSideBarMenu);
                                } else if (pSideBarMenu.id == 'DASHBOARD' || pSideBarMenu.id == 'DOWNLOAD') {
                                    userNavigation.push(pSideBarMenu);
                                }
                            });
                        }
                    }
                });
            }


            const [dashboard] = userNavigation.filter(pUserNavigation => pUserNavigation.title == 'Dashboard');
            const [report] = userNavigation.filter(pUserNavigation => pUserNavigation.title == 'Report');
            const [others] = userNavigation.filter(pUserNavigation => pUserNavigation.title == 'Others');
            userNavigation = userNavigation.filter(pUserNavigation => (pUserNavigation.title != 'Dashboard' && pUserNavigation.title != 'Report' && pUserNavigation.title != 'Others'));

            userNavigation.sort((one, two) => (one.title > two.title ? 1 : -1));
            userNavigation.unshift(dashboard);
            if (others) {
                userNavigation.push(others);
            }
            if (report) {
                userNavigation.push(report);
            }
        }
        this.navigation = userNavigation;
        // </editor-fold>

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);

        this.generalBroadcastService.broadcastNavigation(this.navigation);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        // Add languages
        this._translateService.addLangs(['en', 'bn']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');

        // <editor-fold desc="ngxTranslate Fix" defaultstate="collapsed">
        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         *
         * Set the default language to 'en' and then back to 'tr'.
         * '.use' cannot be used here as ngxTranslate won't switch to a language that's already
         * been selected and there is no way to force it, so we overcome the issue by switching
         * the default language back and forth.
         **/
        /*setTimeout( () => {
         this._translateService.setDefaultLang( 'en' );
         this._translateService.setDefaultLang( 'tr' );
         } );*/
        // </editor-fold>

        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }


    ngOnInit(): void {
        this.generalBroadcastService.sharedTitle
            .pipe(
                tap(title => {
                    this._titleService.setTitle(title);
                })
            )
            .subscribe()
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(pConfig => {
                this.fuseConfig = pConfig;
                // Boxed
                if (this.fuseConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                } else {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];

                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });
        this.loadGoogleMapsApi();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleSidebarOpen(pKey): void {
        this._fuseSidebarService.getSidebar(pKey).toggleOpen();
    }

    setTitle(newTitle: string): void {
        this._titleService.setTitle(newTitle);
    }

    loadGoogleMapsApi(): void {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.configService.mapApiKey}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    _checkNavAccess(pKey: string, pUserModules: Module[], pIsChildren: boolean): boolean {
        const keys = pKey.toUpperCase().split(',').map(key => key.trim());
        if (keys.includes('DASHBOARD')) {
            return true;
        }

        let accessible = false;

        pUserModules.forEach(pModule => {
            if (this.isOrgAdmin || pModule.IsSubscribed === true) {
                if (accessible) {
                    return;
                }
                if (pIsChildren) {

                    pModule.ResourceList.forEach(pResource => {
                        // DON'T use pKey.toUpperCase().contains( pResource.ResourceEnum ) it'll fail for cases like pKey = REPORT_VIEW_ATTENDANCE_REGISTRAR and pResource.ResourceEnum = VIEW_ATTENDANCE
                        if (keys.includes(pResource.Name) && (this.isOrgAdmin || pResource.IsSubscribed === true)) {
                            accessible = true;
                            return;
                        }
                    });
                } else {
                    if (keys.includes(pModule.Name)) {
                        accessible = true;
                        return;
                    }
                }
            }
        });

        return accessible;
    }

    _checkMenuAccess(pKey: string, pUserModules: Module[], pIsChildren: boolean): boolean {
        const keys = pKey.toUpperCase().split(',').map(key => key.trim());
        if (keys.includes('DASHBOARD')) {
            return true;
        }

        let accessible = false;

        pUserModules.forEach(pModule => {
            if (pModule.Name.includes('MENU')) {
                if (this.isOrgAdmin || pModule.IsSubscribed === true) {
                    if (accessible) {
                        return;
                    }
                    if (pIsChildren) {
                        pModule.ResourceList.forEach(pResource => {
                            // DON'T use pKey.toUpperCase().contains( pResource.ResourceEnum ) it'll fail for cases like pKey = REPORT_VIEW_ATTENDANCE_REGISTRAR and pResource.ResourceEnum = VIEW_ATTENDANCE
                            if (keys.includes(pResource.Name) && (this.isOrgAdmin || pResource.IsSubscribed === true)) {
                                accessible = true;
                                return;
                            }
                        });
                    }
                }
            }
        });

        return accessible;
    }
}
